import React, { Component } from 'react'
import GuestUser from './GuestUser';
import RegisteredUser from './RegisteredUser';
import styles from './stylesheets/index.module.css';

export class Stats extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isRegistered: true,
        }
    }
    
    render() {
        const isRegistered = this.state.isRegistered;
        return (
            <div className={styles.statsPage}>
                {
                    isRegistered ?  
                    <RegisteredUser></RegisteredUser>:
                    <GuestUser></GuestUser>
                }
            </div>
        )
    }
}

export default Stats
